export default __webpack_public_path__ + "static/media/not-found-img.4a1e8110.svg";